/// <reference path="../node_modules/jquery/dist/jquery.js"/>
/// <reference path="../node_modules/foundation-sites/dist/js/foundation.d.ts"/>
/// <reference path="./modules/distributor_map.js"/>
/// <reference path="./modules/productpage.js"/>
/// <reference path="./modules/contact_form.js"/>
/// <reference path="../node_modules/slick-carousel/slick/slick.js"/>
/// <reference path="modules/facebook.js"/>
/// <reference path="modules/product_comparison.js"/>
/// <reference path="modules/header.js"/>
/// <reference path="modules/video_carousel.js"/>
/// <reference path="modules/hidden_email.js"/>

$(document).foundation();

if (window.navigator.userAgent.indexOf(".NET") != -1) {
	$("form .dropdown").css("transform", "translateY(-20px)");
}

if ($('.ProductPage').length > 0) {
	ProductPage.init();
}//End HomePage

if ($(document.body).hasClass("DistributorsPage")) {
	DistributorMap.init();
}

if ($('#product-comparison').length) {
	ProductComparison.init();
}

if ($(".ResourcesPage").length > 0 || $(".ResourceGrid").length > 0 || $(".VideoCarouselElement").length > 0) {
	Resources.init();
}


HistorySlider.init();
HiddenEmailController.init();
ContactFormBehaviour.init();
FacebookBehaviour.init();

Webinars.init();

$(document).on('click','.cobb-select',function(e) {
    var select = $(this);
    var selected = select.find('.selected');
    // Close any open selects
    $('.cobb-select').not(this).removeClass('open');
    // If the main/select el is clicked -> toggle open/closed
    if ($(e.target).hasClass('selected')) {
        select.toggleClass('open');
        return false;
    } else {
        var item = $(e.target);
        select.data('value', item.data('id'));
        selected.data('value', item.data('id'));
        selected.text(item.text());
        select.toggleClass('open');
    }
});

function redirectToLocale(newLocale, currentLocale) {
    location.href = `/${newLocale}${currentLocale ? location.pathname.replace("/" + currentLocale, "") : ""}${location.search}`;
}

$(document).on("change", "[locale-language-select]", function() {
	redirectToLocale($(this).val(), $(this).data("current-language"));
});

$(document).on("change", "[locale-region-select]", function() {
	$.get(
		"/ajax/setRegion",
		{
			"ID": $(this).val()
		}
	).done((res) => {
		let data = JSON.parse(res);
		redirectToLocale(data["newLocale"], $("[locale-language-select]").val());
	});
});

$(document).on("click", ".flyout-menu-button", function() {
    $(this).toggleClass('open');
    $('#flyout-menu').toggleClass('open');
    $('body').toggleClass('menu-open');
});

$(document).on("click", ".btn-webinar-register", function(e) {
    var link = $(this).data('link');
    var page = $(this).data('page');
    var title = $(this).data('title');
    // var gaWebinarEvent = ga('send', 'event', 'webinar', 'register', page, title);
    // var gaWebinarEvent = ga('send', {
    //     hitType: 'event',
    //     eventCategory: 'Webinar',
    //     eventAction: 'register',
    //     eventLabel: page,
    //     eventValue: title
    // });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'eventTracking',
        'eventCategory': 'Webinar Registration',
        'eventAction': page,
        'eventLabel': title
    });

    e.stopPropagation();
    window.open(link);
    return false;
});

$(document).on("click", ".btn-download-article", function(e) {
    var articleTitle = $(this).data('title');
    var downloadURL = $(this).attr('href');
    var visitorSource = getCookie('CVWGH_Source');
    var visitorEmail = getCookie('CVWGH_Email');
    var email = visitorEmail.replace('%40', '@');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'eventCategory': 'Gated Download',
        'eventAction': articleTitle,
        'eventLabel': downloadURL + ' - ' + visitorSource + ' - ' + email
    });
    console.log(window.dataLayer);
});

$(document).on("click", ".btn-webinar-nav", function(e) {
    var month = $(this).data('month');
    $('.btn-webinar-nav').addClass('light');
    $(this).removeClass('light');
    $('.accordion-item').hide();
    $('.accordion-item.'+month).show();

    return false;
});

$(document).on("click", ".btn-search", function(e) {
    $('body').addClass('search-open');
    $('.search-view').fadeIn('fast');
    $('#full-search-field').focus();

    return false;
});

$(document).on("click", ".btn-search-submit", function(e) {
    var searchField = $('#full-search-field').focus();
    if (searchField.val() !== '') {
        $(this).parent().submit();
    }
    return false;
});

$(document).on("click", ".close-search", function(e) {
    $('body').removeClass('search-open');
    $('.search-view').fadeOut('fast');
    // $('#full-search-field').blur();

    return false;
});

$('#contact-form').submit(function() {
    var submitMessage = $(this).parent().find('.submit-message');
    $('#contact-form').addClass('loading');
    $('#form-loading').removeClass('hide');

    if (!$(this).hasClass('no-ajax')) {
        $(this).ajaxSubmit({
            success: function(){
                $('#form-loading').addClass('hide');
                $('#contact-form').addClass('hide');
                submitMessage.removeClass('hide');
            }
        });

        return false;
    }
});


$('.tile-slider').each(function() {
    var grid = $(this);
    var count = grid.data('count');
    var prevArrow = grid.parent().find('.tile-prev-slide');
    var nextArrow = grid.parent().find('.tile-next-slide');
    grid.slick({
        infinite: true,
        slidesToShow: count,
        slidesToScroll: 1,
        centerMode: false,
        arrows:true,
        dots:false,
        prevArrow:prevArrow,
        nextArrow:nextArrow,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
          },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
        ]
    });
});

$('#guide-language-select').on('change', function() {
    var locale = $(this).val();
    $('.product-guides-cell').hide();
    $('.language-'+locale).show();
    $.get(
		"/ajax/setGuideLanguage",
		{
			"ID": locale
		}
	).done((res) => {
        console.log(res);
	});

});
$('#resources-language-select').on('change', function() {
    var locale = $(this).val();
    console.log('test');
    $.get(
		"/ajax/setGuideLanguage",
		{
			"ID": locale
		}
	).done((res) => {
        if (locale == 'en_US') {
            location.reload();
        } else {
            if (window.location.pathname == '/resource/featured') {
                window.location = '/resource/product-supplements';
            } else {
                location.reload();
            }
        }
	});

});

function setCookie(cname, cvalue, exdays) {
    if (!exdays) {
        document.cookie = cname + "=" + cvalue + ";path=/";
    } else {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if(!getCookie('CVCC')) {
    $('.consent-bar').fadeIn('fast');
}

$(document).on("click", ".btn-accept-terms", function(e) {
    $('.consent-bar').fadeOut('fast');
    setCookie('CVCC','1',120);
    return false;
});

if(!getCookie('cvreslangpopup')) {
    setTimeout(function() {
        $('.resource-lang-popup').fadeIn();
    }, 1000);
}
if(!getCookie('cvpductlangpopup')) {
    setTimeout(function() {
        $('.product-lang-popup').fadeIn();
    }, 1000);
}

$(document).on('click', '.popup-close', function() {
    var popup = $(this).parent();
    var cookieName = $(this).data('cookie');
    popup.fadeOut('fast');
    setCookie(cookieName,'1',365);
    return false;
});

let cpyw = $("footer .misc .copywrite");
if (cpyw.length > 0) cpyw.html(cpyw.html().replace("~year~", (new Date()).getFullYear().toString()));

HeaderBehaviour.init();
VideoCarouselBehaviour.init();

$(`a[href*="cobb-vantress.adaircreative.com"]`).each(function() {
    $(this).attr("href", $(this).attr("href").replace("cobb-vantress.adaircreative", "cobb-vantress"));
});

// Cobb Academy
$('#signup-form').submit(function() {
    if ($(this).hasClass('loading')) return false;
    $('#signup-form').addClass('loading');

    $(this).ajaxSubmit({
        success: function(resp){
            $('#signup-form').removeClass('loading');
            var signupMessage = $('#signup-message');
            var data = JSON.parse(resp);
            if (data.type == 'success') {
                location.reload();
            } else {
                signupMessage.html(data.message).show();
            }
        }
    });
    return false;
});
$('#login-form').submit(function() {
    if ($(this).hasClass('loading')) return false;
    $('#login-form').addClass('loading');

    $(this).ajaxSubmit({
        success: function(resp){
            $('#login-form').removeClass('loading');
            var loginMessage = $('#login-message');
            var data = JSON.parse(resp);
            if (data.type == 'success') {
                location.reload();
            } else {
                loginMessage.html(data.message).show();
            }
        }
    });
    return false;
});
$('#resetpassword-form').submit(function() {
    if ($(this).hasClass('loading')) return false;
    $(this).addClass('loading');

    $(this).ajaxSubmit({
        success: function(resp){
            $('#resetpassword-form').removeClass('loading');
            var message = $('#resetpassword-error-message');
            var data = JSON.parse(resp);
            if (data.type == 'success') {
                window.location = '/cobb-academy';
            } else {
                message.html(data.message).show();
            }
        }
    });
    return false;
});
$('#forgotpassword-form').submit(function() {
    if ($(this).hasClass('loading')) return false;
    $('#forgotpassword-form').addClass('loading');

    $(this).ajaxSubmit({
        success: function(resp){
            $('#forgotpassword-form').removeClass('loading');
            var errorMessage = $('#forgotpassword-error-message');
            var successMessage = $('#forgotpassword-success-message');
            var data = JSON.parse(resp);
            if (data.type == 'success') {
                successMessage.html(data.message).show();
                errorMessage.hide();
                $('#forgotpassword-form').hide();
            } else {
                errorMessage.html(data.message).show();
            }
        }
    });
    return false;
});

$('#Password_ConfirmPassword').attr('placeholder', 'Confirm Password');
$('.academy-top-nav').on('click', 'a', function() {
    var sectionHref = $(this).attr('href');
    var slug = sectionHref.split('#');
    var sectionEl = $('#'+slug[1]+'');
    $([document.documentElement, document.body]).animate({
        scrollTop: sectionEl.offset().top - 140
    }, 1000);
});

if ($('.video-scroller').length > 0) {
    $('.video-scroller').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay:false,
        autoplaySpeed: 9000,
        speed: 600,
        dots: false,
        appendArrows: $('.video-scroller-nav'),
        prevArrow:'<a class="video-scroller-prev"><i class="fal fa-long-arrow-left"></i></a>',
        nextArrow:'<a class="video-scroller-next"><i class="fal fa-long-arrow-right"></i></a>',
        responsive: [
          {
            breakpoint: 500,
            settings: {
                arrows: false
            }
          },
        ]
    });
}
$(document).on('click', '.btn-play-video', function() {
    var itemID = $(this).data('item');
    var videoID = $(this).data('video');
    var transcript = $(this).data('transcript');
    var reveal = $('#video-scroller-reveal');
    var embed = '<iframe id="video-'+videoID+'" src="https://player.vimeo.com/video/'+videoID+'" width="1280" height="720" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    reveal.find('.content').html(embed);
    reveal.foundation('open');
    $('.accordion').addClass('hide');
    if (transcript) {
        $('#transcript-accordion-'+itemID).removeClass('hide');
    }
    var player = new Vimeo.Player($('#video-'+videoID));
    player.play().then(function() {
        // then
    }).catch(function(error) {
        switch (error.name) {
            case 'PasswordError':
                // the video is password-protected and the viewer needs to enter the
                // password first
                break;

            case 'PrivacyError':
                // the video is private
                break;

            default:
                // some other error occurred
                break;
        }
    });

});

$('[data-reveal]').on('close.zf.trigger', function(){
    var reveal = $(this);
    console.log('close');
    var embedContent = reveal.find('iframe');
    if (embedContent.length) {
        if (embedContent.attr('src').includes('vimeo')) {
            var player = new Vimeo.Player(embedContent[0]);
            player.pause().then(function() {
            }).catch(function(error) {
                switch (error.name) {
                    case 'PasswordError':
                        console.log('vimeo error')
                    break;

                    case 'PrivacyError':
                        console.log('vimeo error')
                        break;

                    default:
                        console.log('vimeo error')
                        break;
                }
            });
        }
    }
});
$('[data-reveal]').on('closed.zf.trigger', function(){
    var reveal = $(this);
    console.log('closed');
    var embedContent = reveal.find('iframe');
    if (embedContent.length) {
        if (embedContent.attr('src').includes('vimeo')) {
            var player = new Vimeo.Player(embedContent[0]);
            player.pause().then(function() {
            }).catch(function(error) {
                switch (error.name) {
                    case 'PasswordError':
                        console.log('vimeo error')
                    break;

                    case 'PrivacyError':
                        console.log('vimeo error')
                        break;

                    default:
                        console.log('vimeo error')
                        break;
                }
            });
        }
    }
});
$(document).on('click', '.reveal-overlay', function(e) {
    if ($(event.target).hasClass('accordion-title')) {
        e.stopPropagation();
        return false;
    } else {
        var reveal = $(this);
        var embedContent = reveal.find('iframe');
        if (embedContent.length) {
            if (embedContent.attr('src').includes('vimeo')) {
                var player = new Vimeo.Player(embedContent[0]);
                player.pause().then(function() {
                }).catch(function(error) {
                    switch (error.name) {
                        case 'PasswordError':
                            console.log('vimeo error')
                        break;

                        case 'PrivacyError':
                            console.log('vimeo error')
                            break;

                        default:
                            console.log('vimeo error')
                            break;
                    }
                });
            }
        }
    }
});


if ($('.countdown').length) {

    $('.countdown').each(function(index, el) {

        // Set the date we're counting down to
        // var countDownDate = new Date("Feb 28, 2022 00:00:00").getTime();
        var releaseDate = el.dataset.date;
        var countDownDate = new Date(releaseDate).getTime();

        // Update the count down every 1 second
        var x = setInterval(function() {

          // Get today's date and time
          var now = new Date().getTime();

          // Find the distance between now and the count down date
          var distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Display the result in the element with id="demo"
          el.innerHTML = '<span class="countdown-cell">' + days + '<span class="countdown-label">Days</span></span>' + '<span class="countdown-cell">' + hours + ' <span class="countdown-label">Hours</span></span>'
          + '<span class="countdown-cell">' + minutes + ' <span class="countdown-label">MINS</span></span>' + '<span class="countdown-cell">' + seconds + ' <span class="countdown-label">SECS</span></span>';

          // If the count down is finished, write some text
          // if (distance < 0) {
          //   clearInterval(x);
          //   document.getElementById("countdown").innerHTML = "EXPIRED";
          // }
        }, 1000);

    });
}


// $('#research-form').submit(function() {
//     var submitMessage = $(this).parent().find('.submit-message');
//     $('#contact-form').addClass('loading');
//     $('#form-loading').removeClass('hide');

//     if (!$(this).hasClass('no-ajax')) {
//         $(this).ajaxSubmit({
//             success: function(){
//                 $('#form-loading').addClass('hide');
//                 $('#contact-form').addClass('hide');
//                 submitMessage.removeClass('hide');
//             }
//         });

//         return false;
//     }
// });